import { render, staticRenderFns } from "./admin-contracts-2023.vue?vue&type=template&id=0d8569dd&scoped=true"
import script from "./admin-contracts-2023.vue?vue&type=script&lang=js"
export * from "./admin-contracts-2023.vue?vue&type=script&lang=js"
import style0 from "./admin-contracts-2023.vue?vue&type=style&index=0&id=0d8569dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8569dd",
  null
  
)

export default component.exports